import React from 'react'
import { Ripple } from '@progress/kendo-react-ripple'
import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout'
import { Button } from '@progress/kendo-react-buttons'
import { Popup } from '@progress/kendo-react-popup'
import { Icon } from '@progress/kendo-react-common'

import Env from '../../Env'
import { useAppSelector } from '../../stores'
import { AppMenu } from './AppMenu'
import { BlobFileService } from '../../services'
import { LinkButton } from '../elements'
import { LoginUserInfoCard } from '../parts'
import HelpSettings from '../../data/HelpSettings.json'

export default function AppHeader() {
  const commonState = useAppSelector(state => state.common)

  const menuAnchor = React.useRef<HTMLDivElement>(null)
  const [showMenu, setShowMenu] = React.useState(false)

  function toggleMenu() {
    setShowMenu(!showMenu)
  }

  function closeMenu() {
    setShowMenu(false)
  }

  const userAuthority = commonState.userProp?.authority
  const help = HelpSettings.find(help => help.authority === userAuthority)

  function openHelp() {
    const blob = new BlobFileService()
    if (help != null) {
      blob.download('manuals', help.fileName)
        .then(link => window.open(link))
        .catch(() => {})
    }
  }

  return (
    <div ref={menuAnchor}>
      <AppBar className='k-appbar-primary' themeColor='inherit'>
        <AppBarSection>
          <Button icon='menu' fillMode="flat" togglable selected={showMenu} onClick={toggleMenu}>
            <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>Menu</span>
          </Button>
          <Popup
            show={showMenu}
            anchor={menuAnchor.current}
            className="pcy-app-menu-popup"
            style={{ width: '100%' }}>
            <Ripple>
              <AppMenu onMenuClicked={closeMenu} />
            </Ripple>
            <Button icon='arrow-chevron-up' fillMode="flat" size="small" onClick={closeMenu} />
          </Popup>
        </AppBarSection>
        <AppBarSection>
          <LinkButton to='/'><span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{Env.SYSTEM_TITLE}</span></LinkButton>
          {(commonState.pageTitle !== '') && (
            <>
              <Icon name="arrow-chevron-right" style={{ fontWeight: 'bold', marginLeft: '10px', color: '#f9f9f9' }} />
              <span>{commonState.pageTitle}</span>
            </>
          )}
        </AppBarSection>
        <AppBarSpacer />
        <AppBarSection>
          <LoginUserInfoCard />
        </AppBarSection>
        <AppBarSection>
          {(help?.fileName ?? '') !== '' &&
            <>
            <Button icon='help' fillMode="flat" onClick={openHelp} />
            </>
          }
        </AppBarSection>
      </AppBar>
    </div>
  )
}
